import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToMoney = () => {
    document.getElementById('money-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-6 px-5 md:pt-10 md:pb-12 overflow-hidden" data-id="element-78">
      <div className="max-w-4xl mx-auto text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-80">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl text-charcoal leading-[1.1] mb-3" data-id="element-81">
            Calm Your Nervous System in 5 Minutes (Even If Nothing Else Has
            Worked)
          </h1>

          <p className="text-base md:text-lg text-charcoal-light max-w-2xl mx-auto mb-5 leading-relaxed" data-id="element-82">
            The 5-Minute 'Neural Circuit Breaker' for Women Who Are Tired of
            Being Stressed.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-[300px] mx-auto mb-5" data-id="element-83">
          <div className="aspect-[4/5] relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-84">
            <img src="https://cdn.magicpatterns.com/uploads/wkZSzuyJiLzekd5DqSr7dv/MP_Mockup_-_The_Nervous_System_Reset.png" alt="The Nervous System Reset Product Mockup" className="object-cover w-full h-full" data-id="element-85" />
          </div>
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-sand rounded-full blur-3xl opacity-50" data-id="element-86"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-87">
          <motion.button onClick={scrollToMoney} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto bg-terracotta hover:bg-terracotta-dark text-white font-semibold text-base md:text-lg py-3.5 px-8 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-88">
            Reset My Nervous System Now
          </motion.button>
          <p className="mt-2.5 text-xs text-charcoal-light font-medium flex items-center gap-1.5" data-id="element-89">
            <span className="w-1.5 h-1.5 rounded-full bg-sage animate-pulse" data-id="element-90"></span>
            Instant digital download • Read on any device
          </p>
        </motion.div>
      </div>
    </section>;
}